import _ from "lodash";
import intl from "react-intl-universal";
import httpService from "../_utils/http-service";
import { LIMIT } from "../_utils/constants";
import * as types from "./types";
import { getHttpConfig, getAuthHttpConfig } from "../_utils/auth-utils";
import { traceEvent } from "../_utils/analytics-utils";


export const getBannerRestaurants = (bannerId, callback) => {
  return function(dispatch, getState) {
    traceEvent("bannerRestaurants", "search");
    let url = `/v2/restaurants/promotions/${bannerId}`;

    url = url + `?limit=${LIMIT}`;
    let httpConfig = getHttpConfig();

    const storage = getState().storage;

    if (storage.authToken !== undefined) {
      httpConfig = getAuthHttpConfig(storage);
    }

    httpService
      .get(url, httpConfig)
      .then(res => {
        if (res.data.statusCode === 200) {
          let bannerRestaurants = res.data.data;
          callback({ bannerRestaurants });
        } else {
          traceEvent("error", "searchRestaurants");
          callback({ error: res.data.message });
        }
      })
      .catch(err => {
        traceEvent("error", "searchRestaurants");
        callback({ error: intl.get("general.serverError") });
      });
  };
};

export const setBannerRestaurantsFound = bannerRestaurants => {
  return { type: types.BANNER_RESTAURANTS_FOUND, payload: bannerRestaurants };
};

export const clearBannerRestaurantsFound = () => {
  return { type: types.BANNER_RESTAURANTS_CLEAR };
};
